import { render } from "./NotFound.vue?vue&type=template&id=5bcc8ebf&ts=true"
import script from "./NotFound.ts?vue&type=script&lang=ts&external"
export * from "./NotFound.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__